"use client";
import Heading from "@/components/molecules/Heading";
import PowerBIDashboard from "@/components/organisms/PowerBI/PowerBIDashboard";
import React from "react";
import { StatsPowerBiBlockProps } from "./types";
import BupiLink from "@/components/atoms/link";

export default function StatsPowerBiBlock(data: StatsPowerBiBlockProps) {
  return (
    <div className="container mx-auto">
      <div className="flex flex-col xl:flex-row">
        <div className="w-full xl:w-1/4">
          <Heading title={data?.title} description={data?.description} />
        </div>
        <div className="mt-16 md:mt-0 w-full xl:ml-104 xl:w-3/4">
          <PowerBIDashboard dashboardType="mainPage" />

          <BupiLink
            url={data.url ?? "#"}
            target={data.target ?? "_self"}
            hasIcon
            label={data.label}
            className="agora-anchor-link-primary mt-24 text-m-semibold py-16 flex items-center justify-between gap-8 md:justify-start text-primary-600"
          />
        </div>
      </div>
    </div>
  );
}
